module.exports = __webpack_public_path__ + "img/logo.cc8655b8.svg";